import { EnterPinForm } from "@/entities/enter-pin";
import { appRouterPaths } from "@/services/navigation";
import type { RouteProps } from "react-router-dom";

export const enterPinPageRoute: RouteProps = {
  path: appRouterPaths.enterPin,
  element: <EnterPinForm />,
};
